import type {
  ApiDashboardElement,
  SelectionSchemaMeasurePoint,
  SelectionSchemaProjectSite,
} from '@highimpact-frontend/api-types';

/** Type guard for measure-point selection paths on dashboard elements. */
export function isPathWithMeasurePoint(
  path: ApiDashboardElement['data_source'][number]
): path is SelectionSchemaMeasurePoint {
  return 'measure_point_id' in path && 'measure_type_id' in path;
}

/** Type guard for project/site selection paths on dashboard elements. */
export function isPathWithProjectSite(
  path: ApiDashboardElement['data_source'][number]
): path is SelectionSchemaProjectSite {
  return 'project_id' in path && 'site_id' in path;
}

export function areAllPathsWithMeasurePoint(
  paths: ApiDashboardElement['data_source']
): paths is SelectionSchemaMeasurePoint[] {
  return paths.every(isPathWithMeasurePoint);
}

export function areAllPathsWithProjectSite(
  paths: ApiDashboardElement['data_source']
): paths is SelectionSchemaProjectSite[] {
  return paths.every(isPathWithProjectSite);
}
